import "./AboutPureDetail.module.css";
import PureDetailHeader from "@/reusable_sections/Header";
import FamilyStoryAboutUs from "./sections/FamilyStoryAboutUs";
import OwnerOperatedOversightWhyUs from "./sections/OwnerOperatedOversightWhyUs";
import PureDetailFooter from "@/reusable_sections/Footer";
export default function AboutPureDetailPage() {
  return <div>
      <PureDetailHeader />
      <FamilyStoryAboutUs />
      <OwnerOperatedOversightWhyUs />
      <PureDetailFooter />
    </div>;
}